// extracted by mini-css-extract-plugin
export default {"infoIcon":"AvailabilityDisplay_infoIcon__cUkpK","thresholdInput":"AvailabilityDisplay_thresholdInput__0CU0-"};